import {createSlice} from "@reduxjs/toolkit";

const initialState = {
	state: {
		roomCode: ''
	}
}

export const liveSlice = createSlice({
	name: 'live',
	initialState,
	reducers: {
		// state的集合体
		setLiveStateToStore: (state, action) => {
			state.state = Object.assign({}, state.state, action.payload)
		}
	},
	extraReducers: (builder => {})
})

export const {
	setLiveStateToStore
} = liveSlice.actions

export const getLiveInfo = (state) => state.live.state

export default liveSlice.reducer
